import { apiRequest, type FetchFn } from './client';
import type { SignedContact } from '../telegram/webapp';

/** Mini App login (Konstantin's contract): initData goes as is, the body is the resident token. */
export function login(fetchFn: FetchFn, baseUrl: string, initData: string): Promise<string> {
  return apiRequest<string>(fetchFn, baseUrl, '/tg-miniapp/v1/auth/login', {
    method: 'POST',
    body: { initData },
  });
}

/** Max mini app login (docs/external/2026-11-01-max-miniapp-login-tz.md): the same contract with Max initData. */
export function loginMax(fetchFn: FetchFn, baseUrl: string, initData: string): Promise<string> {
  return apiRequest<string>(fetchFn, baseUrl, '/max-miniapp/v1/auth/login', {
    method: 'POST',
    body: { initData },
  });
}

/** Max hands the signed phone to the app: mobile-api checks it against initData and answers with the token. */
export function confirmMaxPhone(fetchFn: FetchFn, baseUrl: string, initData: string, contact: SignedContact): Promise<string> {
  return apiRequest<string>(fetchFn, baseUrl, '/max-miniapp/v1/auth/phone', {
    method: 'POST',
    body: { initData, contact },
  });
}

/** tenant-api logout: v1 blacklists the token (browser «Выйти», #4218). Called without relogin on purpose. */
export function logout(fetchFn: FetchFn, baseUrl: string, token: string): Promise<null> {
  return apiRequest<null>(fetchFn, baseUrl, '/v1/auth/logout', { method: 'POST', token });
}
